/**
 * Seleccion acumulada de variantes en el detalle de la lista de precios.
 *
 * Flujo: buscar un estilo, marcar sus variantes, buscar otro, marcar mas, y
 * aplicar oferta o precios a todo junto. La tabla solo conoce la pagina
 * visible; esta seleccion guarda lo marcado en TODAS las busquedas.
 *
 * El problema que resuelve: al cambiar las filas (nueva busqueda, pagina o
 * filtro) la b-table de BootstrapVue limpia su seleccion interna y emite
 * "ninguna fila seleccionada". Si se volvia a un estilo ya marcado, ese aviso
 * llegaba antes de re-marcar sus filas y se tomaba como "el usuario las
 * desmarco": la seleccion se perdia. Mientras `syncing` esta activo, los avisos
 * de la tabla se ignoran.
 *
 * Funciones puras sobre un objeto de estado plano, para que el componente lo
 * tenga en `data` (reactivo) y para poder probarlas sin Vue.
 */

/* Estas funciones actualizan a proposito el estado que reciben: es el objeto
   reactivo del componente (data.selection). */
/* eslint-disable no-param-reassign */

export function createSelection() {
  return { rows: [], syncing: false }
}

const porSku = (a, b) => a.product_variant.sku.localeCompare(b.product_variant.sku)

/**
 * Evento de la tabla: `selectedOnPage` son las filas marcadas de la pagina
 * visible (`visibleRows`). De lo visible queda solo lo marcado; lo de otras
 * busquedas se conserva. Devuelve false si se ignoro (sincronizando).
 */
export function applyTableSelection(selection, visibleRows, selectedOnPage) {
  if (selection.syncing) return false

  const visibles = new Set(visibleRows.map(r => r.id))

  selection.rows = selection.rows
    .filter(r => !visibles.has(r.id))
    .concat(selectedOnPage)
    .sort(porSku)

  return true
}

/** Indices de la pagina que deben volver a marcarse en la tabla. */
export function rowsToRestore(selection, pageRows) {
  const elegidos = new Set(selection.rows.map(r => r.id))

  return pageRows.reduce((indices, row, i) => {
    if (elegidos.has(row.id)) indices.push(i)
    return indices
  }, [])
}

export function removeFromSelection(selection, id) {
  selection.rows = selection.rows.filter(r => r.id !== id)
}

export function clearSelection(selection) {
  selection.rows = []
}
